import moment from "moment";

// Round to the nearest second so when you display the jobDuration twice they look synced
// Instead of one updating and then the other updating half a second later
const roundSec = (d: Date | null | undefined) =>
  d ? new Date(Math.round(d.getTime() / 1000) * 1000) : d;

export const displayJobTime = (duration: moment.Duration) => {
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  return `${hours ? hours + "h " : ""}${minutes ? minutes + "m " : ""}${seconds}s`.trim();
};

export const jobDuration = (start: Date | null | undefined, end: Date | null | undefined) => {
  const roundedStart = roundSec(start);
  const roundedEnd = roundSec(end);

  const milliseconds = moment(roundedEnd).diff(moment(roundedStart));
  const duration = moment.duration(milliseconds);

  return displayJobTime(duration);
};
